<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="title is-1">Liens</div>
      <br />
      <div v-if="questions && questions.length > 0">
        <div class="title is-2">Pre-CTC</div>
        <p>Country: {{ CountryName }}</p>
        <question v-model="questions[0]" @change="change($event, '0')"></question>
        <div v-if="!hideUnregistered">
          <question v-model="questions[1]" v-if="unregistered" @change="change($event, '1')" column></question>
          <question v-model="questions[2]" v-if="selectedOther" @change="change($event, '2')"></question>
          <div class="title is-3" style="margin-top: 30px">2. Please Outline the extent of the priority of each category of unregistered priority lien.</div>
          <question v-model="questions[3]" @change="change($event, '3')"></question>
          <question v-model="questions[4]" @change="change($event, '4')"></question>
          <question v-model="questions[5]" @change="change($event, '5')"></question>
          <br />
          <div class="title is-3" style="margin-top: 30px">3. Please outline any conditions to the validity of, or limitations on, the priority of each category of unregistered priority lien.</div>
          <question v-model="questions[6]" @change="change($event, '6')"></question>
          <question v-model="questions[7]" @change="change($event, '7')"></question>
          <question v-model="questions[8]" @change="change($event, '8')"></question>
          <question v-model="questions[9]" @change="change($event, '9')"></question>
        </div>
        <div class="title is-2" style="margin-top: 30px">CTC</div>
        <question v-model="questions[10]" @change="change($event, '10')" column></question>
        <div v-if="declaration39">
          <question v-model="questions[11]" @change="change($event, '11')" column></question>
          <question v-model="questions[12]" @change="change($event, '12')" column></question>
          <question v-model="questions[13]" @change="change($event, '13')"></question>
        </div>
      </div>
      <br /><br />
      <div v-if="IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/1')">Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/3')">Next</b-button>
          </div>
        </div>
      </div>
      <div v-if="!IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button class="button is-primary" @click="save">Save</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: new Promise((resolve, reject) => { })
      }
    },
    props: {
      exporting: Boolean
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/1');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/3');
        });
      },
      async save() {
        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.Liens);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.Liens);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      this.qpromise =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.Liens, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');

              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });

      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      var self = this;
      this.qpromise.then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },
    computed: {
      declaration39() {
        if (this.questions[10].model == 52) {
          return true;
        } else {
          this.questions[11].model = null;
          this.questions[12].model = null;
          this.questions[13].model = null;
          return false;
        }
      },
      hideUnregistered() {
        if (this.questions[0].model == 47) {
          for (var i = 1; i <= 9; i++)
            this.questions[i].model = null;
          return true;
        } else {
          return false;
        }
      },
      unregistered() {
        if (this.questions[0].model == 46) {
          return true;
        } else {
          return false;
        }
      },
      selectedOther() {
        if (this.questions[1].model != null && this.questions[1].model.some(model => model == 51)) {
          return true;
        } else {
          return false;
        }
      },
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      },
      CountryName() {
        if (this.exporting)
          return this.$parent.options.CountryName;
        else
          return this.$store.getters.currentQuestionnaire.CountryName;
      }
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>
